
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/college/[slug]",
      function () {
        return require("private-next-pages/college/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/college/[slug]"])
      });
    }
  